module.exports = __webpack_public_path__ + "img/header.cb04ba9c.jpg";